module.exports = __webpack_public_path__ + "img/sweat.89ccc154.png";